import { Outlet, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { loadingState } from "../global/LoaderState";
import Footer from "./Footer";
import Header from "./Header";
import TokenChecker from "services/TokenChecker";
import RoleGuard from "routes/RoleGuard";

function Layout() {
  const location = useLocation();
  const isLoginPage =
    location.pathname === "" ||
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/sign-in" ||
    location.pathname === "/candidate-login" ||
    location.pathname === "/404";
  const [isLoading] = useRecoilState(loadingState);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <TokenChecker />
      <Header />
      <div style={{ flex: "1" }}>
        <RoleGuard>
          <Outlet />
        </RoleGuard>
      </div>
      {!isLoginPage && !isLoading && <Footer />}
    </div>
  );
}

export default Layout;
